import { render, staticRenderFns } from "./DiagnosticRecord.vue?vue&type=template&id=0ded452d&scoped=true"
import script from "./DiagnosticRecord.vue?vue&type=script&lang=js"
export * from "./DiagnosticRecord.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticRecord.vue?vue&type=style&index=0&id=0ded452d&prod&scoped=true&lang=css"
import style1 from "./DiagnosticRecord.vue?vue&type=style&index=1&id=0ded452d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded452d",
  null
  
)

export default component.exports